<template>
  <div ref='graph' class="graph-div">
    <div class="tab" :height="tableHeight" :alt="tableHeight">
      <div v-for="item in graphNav" :key="item.value" class="tab-buy" :style="elseTabStyle"
        :class="{'card_title_select':active==item.value}" @click="clickTab(item.value)">
        <p>{{tableHeight>400?item.label:item.simple}}</p>
      </div>
    </div>
    <div class='quote-graph-flex' ref="stockkline">
      <!-- 正常视图（分时k线等） -->
      <div class='quote-graph-container' style="display: contents;">
        <!-- canvas容器 -->
        <div class="canvas-minute" v-show="active === 1">
          <preiod-nav ref="preiod" :list='minuteBar.list' :active='minuteBar.active' @navClick="minuteNavChange"></preiod-nav>
          <div id="minute" ref="minute" style="position:relative"></div>
        </div>
        <div class="canvas-minute" v-show="active === 2">
          <preiod-nav :list='klineBar.list' :active='klineBar.active' @navClick="klineNavChange"></preiod-nav>
          <div id="kline" ref='kline' style="position:relative"></div>
        </div>
        <div ref='graphComponent' v-show="active === 1 || active === 2">
          <div class="menu-list">
            <div class="item" :class="menuIndex===index?'item-active':''" v-for="(item,index) in menuList" :key="item"
              @click="OnClickIndexBar(item,index)">
              {{item}}</div>
          </div>
        </div>
        <!-- F10信息容器 -->
        <div v-show='active === 3' :height="tableHeight" :alt="tableHeight" class="f10-container-wrap">
          <p class="f10-title" align="center" v-html="goodsTitle"></p>
          <div class="w-e-text-container">
            <div contenteditable="false" class="f10-content w-e-text">
              <p align="left" class="goods-info-p" :style="infoStyle" v-html="goodsContent"></p>
            </div>
          </div>
        </div>
        <!-- 分笔成交容器 -->
        <div v-show='active === 4' class="container-wrap" ref="tickContainer" style="overflow: hidden;position: relative;">
          <p class="ticks-title" align="center">{{this.goods.code}}&nbsp;&nbsp;{{this.goods.name}}</p>
          <div class="pageBar">
            <h-button type="text" @click="prevHandle" :disabled="!isPrevEnable" title="上一页">上一页</h-button>
            <h-button type="text" @click="nextHandle" :disabled="!isNextEnable" title="下一页">下一页</h-button>
          </div>
          <div class="list-box tick-container-wrap" :style="pageStyle">
            <div class="list-box-view" v-for="(item,index) in dataList" :key="index">
              <div class="list-item" v-for="(child,vIndex) in item" :key="vIndex" :class="activeIndex == vIndex && activeColIdx == index ? 'tick-active' : ''" @click="changeColor(vIndex, index)">
                <span class="label">{{child.time}}</span>
                <span class="price" :class="child.color">{{child.price}}</span>
                <span class="count" :class="child.color">{{child.vol}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 分价表容器 -->
        <div v-show='active === 5' class="container-wrap rate-table">
          <p class="ticks-title" align="center">{{this.goods.code}}&nbsp;&nbsp;{{this.goods.name}}</p>
          <h-row>
            <h-col span="12" class="rate-table-body">
              <h-table :columns="columns" :data="buyTicks" :height="tickTableHeight" :disabled-hover="true" class="black" no-data-text="">
              </h-table>
            </h-col>
            <h-col span="12" class="rate-table-body">
              <h-table :columns="columns" :data="selTicks" :height="tickTableHeight" :disabled-hover="true" class="black" no-data-text="" :headerHeight="30">
              </h-table>
            </h-col>
          </h-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTrend, getTrendMinute, getKline, getGoodsInfo, getTicksList, getServerTime } from '@frame/api/chart/chart'
import HQChart from 'hqchart'
import PreiodNav from './preiodNav'
import unit from '@frame/utils/unit'
import { dateFormat } from '@frame/utils/Utils'
import 'hqchart/src/jscommon/umychart.resource/css/tools.css'
import 'hqchart/src/jscommon/umychart.resource/font/iconfont.css'
import { GetMinuteOption, GetKLineOption, setTradeTime, IndexBar, getOsInfo, closeDebug, tradeTime } from './chartOptions'
import { setOptionalData, getOptionalData } from '@common/utils/tools'
var Mousetrap = require('mousetrap')
let optionsList = []
const tickFields = 'business_time,hq_px,business_balance,business_amount,business_direction'
const period = { 0: 6, 1: 7, 2: 8, 3: 9, 4: 1, 5: 2, 6: 3, 7: 4, 8: 5 }
const default_ticks = 999999
const col_width = 249
export default {
  name: 'QuoteView',
  data () {
    return {
      minuteBar: {
        active: 1,
        list: [
          { label: '分时', value: 1 },
          { label: '五日', value: 2 },
          // { label: 'K线', value: 3 },
          {
            label: '添加自选',
            value: 20,
            render: (h, params) => {
              return this.navRender(h)
            }
          },
        ]
      },
      graphNav: [
        { label: '分时走势', simple: '分时', value: 1 },
        { label: '技术分析', simple: '分析', value: 2 },
        { label: '基本资料', simple: '资料', value: 3 },
        { label: '分笔成交', simple: '成交', value: 4 },
        { label: '分价表', simple: '分价', value: 5 },
      ],
      menuList: [],
      menuIndex: 0,
      minIndex: 0,
      kIndex: 0,
      klineBar: {
        active: 0,
        list: [
          { label: '日线', value: 0 },
          { label: '周线', value: 1, },
          { label: '月线', value: 2, },
          { label: '年线', value: 3, },
          { label: '1分钟', value: 4, },
          { label: '5分钟', value: 5, },
          { label: '15分钟', value: 6, },
          { label: '30分钟', value: 7, },
          { label: '60分钟', value: 8, },
          // { label: '分时', value: 9, },
          {
            label: '添加自选',
            value: 20,
            render: (h, params) => {
              return this.navRender(h)
            }
          },
        ]
      },
      tableHeight: 400,
      elseTabStyle: {
        width: '100%',
        display: 'flex',
        flex: '1 1 auto',
        height: '80px'
      },
      active: 1,
      Symbol: '600000.sh',
      Minute: {
        JSChart: null,
        Option: null,
      },
      KLine: {
        JSChart: null,
        Option: null,
      },
      system: {},
      operator: null,
      goodsTitle: '',
      goodsContent: '',
      hasOptional: false,
      prodCode: '',
      tickList: [],
      columns: [
        { title: '序号', key: 'index', width: 40 },
        { title: '价格', key: 'price' },
        { title: '数量', key: 'amount' },
        { title: '笔数', key: 'count', width: 50 },
        { title: '总额', key: 'balance' },
        { title: '比例（%）', key: 'rate', width: 70 },
        {
          title: '比例图',
          key: 'rateImage',
          render: (h, p) => {
            let val = Number(p.row.rate)
            return h('h-progress', {
              props: {
                // 解决小于0.12时无法体现比例，所以默认为0.12
                percent: val < 0.12 ? 0.12 : val,
                strokeWidth: 14,
                hideInfo: true
              }
            }, '')
          }
        },
      ],
      dataList: [],
      buyTicks: [],
      selTicks: [],
      indexItem: '',
      realKline: {
        data: null,
        func: null
      },
      realMinute: {
        data: null,
        func: null
      },
      klineInited: false,
      minuteInited: false,
      activeIndex: -1,
      activeColIdx: -1,
      pageStyle: {
        left: '0px',
        position: 'absolute'
      },
      pageNo: 1,
      totalPage: 0,
      movingPixels: 0,
      movingDistance: 0,
      isPrevEnable: false,
      isNextEnable: true,
      lastTime: null,
      prePrice: 0,
      totalTime: 0,
      currDate: '',
      currTime: ''
    }
  },
  components: {
    PreiodNav
  },
  props: {
    height: Number,
    width: Number,
    show: Boolean,
    code: {
      type: [Number, String],
      required: true,
    },
    goods: String
  },
  computed: {
    infoStyle () {
      let height = this.tableHeight - 45
      return {
        height: height + 'px'
      }
    },
    tickTableHeight () {
      return this.tableHeight - 26
    }
  },
  created () {
    // 设置图表参数
    this.Minute.Option = GetMinuteOption(this.code)
    this.KLine.Option = GetKLineOption(this.code)

    // 底部指标工具
    this.menuList = IndexBar.Menu

    this.operator = HQChart.Chart.IFrameSplitOperator
  },
  mounted () {
    // 获取当前操作系统
    this.system = getOsInfo()
    Mousetrap.bind(['f10'], (event) => {
      switch (event.key) {
        case 'F10':
          this.getF10Info()
          this.clickTab(3)
          break
        default:
          break
      }
    })
    this.$nextTick(() => {
      this.createMinuteChart()
      this.createKLineChart()
      // 设置k线图宽高
      this.setCanStyle()
    })
    optionsList = getOptionalData('goodsOptionalData')
    this.prodCode = this.code.indexOf('.ET') >= 0 ? this.code.replace('.ET', '') : this.code
    this.hasOptional = !!optionsList.find(v => v === this.prodCode)
    this.currentTime()
    this.updateLocalTime()
    // 刷新K线数据
    this.$bus.$on('klineRealRefresh', (kline = {}) => {
      this.refreshKline(kline)
    })
  },
  beforeDestroy () {
    // 解绑 eventBus事件
    this.busOff(['klineRealRefresh'])
    this.destroyChart()
  },
  watch: {
    // 监听，显示k线图，监听窗口尺寸变化
    show: {
      handler (nv, ov) {
        if (!nv) {
          window.onresize = () => {
            this.setCanStyle()
          }
        }
      },
      immediate: true
    },
    'pageNo': {
      handler (nv, ov) {
        if (nv === 1) {
          this.isPrevEnable = false
          this.isNextEnable = true
        }
        if (nv === this.totalPage) {
          this.isPrevEnable = true
          this.isNextEnable = false
        }
        if (nv > 1 && nv < this.totalPage) {
          this.isPrevEnable = true
          this.isNextEnable = true
        }
      }
    },
    'totalPage': {
      handler (nv, ov) {
        this.isNextEnable = nv > 1
      }
    }
  },
  methods: {
    navRender (h) {
      let renderArr = []
      if (this.hasOptional) {
        renderArr.push(h('Button', {
          props: {
            size: 'small',
            type: 'primary',
            icon: 'android-remove'
          },
          class: 'optional-btn',
        }, '自选'))
      } else {
        renderArr.push(h('Button', {
          props: {
            size: 'small',
            type: 'primary',
            icon: 'android-add'
          },
          class: 'optional-btn'
        }, '自选'))
      }
      return h('div', renderArr)
    },
    // 获取商品信息
    getF10Info () {
      const { code, name } = this.goods
      const opt = { goods_code: code }
      let that = this
      getGoodsInfo(opt).then((r) => {
        let ds = r.data
        if (ds.errorNo === '0' && ds.items.length) {
          that.goodsTitle = r.data.items[0].f10Title
          that.goodsContent = r.data.items[0].f10Content
        } else {
          that.goodsTitle = ''
          that.goodsContent = `暂无${code}[${name}]F10信息`
        }
      }).catch((e) => {
        console.error(e)
        that.goodsContent = ''
      })
    },
    setCanvasHeight () {
      let kHeight = this.tableHeight < 300 ? 300 : this.tableHeight
      kHeight = kHeight - 50
      return kHeight
    },
    back () {
      this.isFullScreen = false
    },
    clickTab (number) {
      this.active = number
      if (number === 1 || number === 2) {
        this.OnClickIndexBar(this.indexItem, this.menuIndex)
      }
      if (number === 1) {
        this.minuteNavChange({ value: this.minuteBar.active })
      }
      if (number === 2) {
        this.klineNavChange({ value: this.klineBar.active })
      }
      if (number === 3) {
        this.getF10Info()
      }
      if (number === 4) {
        this.qryMinuteTick()
      }
      if (number === 5) {
        this.qryPriceTable()
      }
    },
    // 设置K线图的宽高
    setCanStyle () {
      let content = document.querySelector('.quotation-content')
      let cavHeight = content.clientHeight
      let cavWidth = content.clientWidth

      this.tableHeight = cavHeight - 8
      let height = cavHeight / 5
      height = height < 60 ? 60 : height
      this.elseTabStyle.height = `${height}px`

      cavWidth = cavWidth - 250 - 18

      let kHeight = this.setCanvasHeight()
      let obj = {
        width: cavWidth,
        height: kHeight,
      }
      if (this.$refs.stockkline) this.OnSize(obj)
    },
    OnSize (objData) {
      var minute = this.$refs.minute
      minute.style.width = objData.width + 'px'
      minute.style.height = objData.height + 'px'

      if (this.Minute.JSChart) this.Minute.JSChart.OnSize()

      var kline = this.$refs.kline
      kline.style.width = objData.width + 'px'
      kline.style.height = objData.height + 'px'
      if (this.KLine.JSChart) this.KLine.JSChart.OnSize()
    },
    /**
       * 创建日线图
       **/
    createMinuteChart () {
      if (this.Minute.JSChart) return
      // 设置商品
      this.Minute.Option.Symbol = this.code
      // 设置黑色主题
      let blackStyle = HQChart.Chart.HQChartStyle.GetStyleConfig(
        HQChart.Chart.STYLE_TYPE_ID.BLACK_ID
      )
      HQChart.Chart.jsChartStyle(blackStyle)

      let JSChart = HQChart.Chart.JSChart
      var resource = JSChart.GetResource()
      // 设置字体大小
      resource.FrameSplitTextFont = this.system.name === 'Mac' ? '28px 微软雅黑' : '14px 微软雅黑'
      let chartW = document.querySelector('.left-view').clientWidth
      // 设置交易时间段
      setTradeTime(JSChart, chartW)
      // 绑定网络协议回调
      this.Minute.Option.NetworkFilter = (data, callback) => {
        this.minuteNetworkFilter(data, callback)
      }
      let minuteRef = this.$refs.minute
      // 设置走势图高度
      minuteRef.style.height = this.setCanvasHeight()
      // 初始化走势图
      let chart = JSChart.Init(minuteRef)
      chart.OnSize()
      // 设置配置项
      chart.SetOption(this.Minute.Option)
      // 保存图表对象
      this.Minute.JSChart = chart
      // 关闭控制台日志
      closeDebug(HQChart.Chart)
    },
    /**
       *  创建K线图
       **/
    createKLineChart () {
      const me = this
      if (me.KLine.JSChart) return
      // 设置商品
      me.KLine.Option.Symbol = me.code
      let chart = HQChart.Chart.JSChart.Init(me.$refs.kline)
      // 绑定网络协议回调
      me.KLine.Option.NetworkFilter = (data, callback) => {
        me.klineNetworkFilter(data, callback)
      }
      // 设置配置项
      chart.SetOption(me.KLine.Option)
      // 保存图表对象
      me.KLine.JSChart = chart
      // 关闭控制台日志
      closeDebug(HQChart.Chart)
    },
    /**
       * 走势图-切换tab
       **/
    minuteNavChange (item) {
      if (item.value === 20) {
        this.editOptional()
        return
      }
      if (item.value === 3) {
        this.menuIndex = this.kIndex
        this.clickTab(2)
        return
      }
      this.minuteBar.active = item.value
      this.Minute.JSChart.OnSize()
      this.Minute.JSChart.ChangeDayCount(item.value)
    },
    /**
       *  k线图-切换tab
       **/
    klineNavChange (item) {
      if (item.value === 20) {
        this.editOptional()
        return
      }
      if (item.value === 9) {
        this.menuIndex = this.minIndex
        this.clickTab(1)
        return
      }
      this.klineBar.active = item.value
      this.KLine.JSChart.ChangePeriod(item.value)
    },
    /**
      * 绑定网络协议回调 分时图
      **/
    minuteNetworkFilter (data, callback) {
      const active = this.active
      data.PreventDefault = true
      if (active === 1 || !this.minuteInited) {
        const { Name } = data
        this.minuteInited = true
        this.realMinute.data = data
        this.realMinute.func = callback
        // 分时图-获取数据
        if (Name === 'MinuteChartContainer::RequestMinuteData') {
          const { field, symbol } = data.Request.Data
          let option = {
            field: field.slice(0, field.length - 2),
            symbol: symbol[0],
          }
          return this.qryTrend(option, callback)
        }
        // 五日走势图-获取数据
        if (Name === 'MinuteChartContainer::RequestHistoryMinuteData') {
          const { symbol, daycount } = data.Request.Data
          let option = {
            dataCount: daycount,
            symbol: symbol,
          }
          return this.qryTrendMinute(option, callback)
        }
      }
    },
    klineNetworkFilter (data, callback) {
      // 设置hqchart不请求数据
      const active = this.active
      const index = this.klineBar.active
      data.PreventDefault = true
      if (active === 2 || !this.klineInited) {
        this.klineInited = true
        // 不请求流通股本数据
        const { Name } = data
        const { mklineCount, dklineCount } = window.LOCAL_CONFIG
        if (Name === 'KLineChartContainer::RequestFlowCapitalData') {
          // eslint-disable-next-line standard/no-callback-literal
          return callback({ code: 0, stock: [] })
        }
        // 保存请求参数及回调函数
        this.realKline.data = data
        this.realKline.func = callback
        const { field, symbol, count } = data.Request.Data
        let dataCount = count
        let fields = field
        let candlePeriod = period[index]
        if (fields.indexOf('date') < 0) {
          fields.push('date')
        }
        // 1分钟K线数据（全量）
        let isFull = Name === 'KLineChartContainer::ReqeustHistoryMinuteData'
        if (isFull) {
          dataCount = dklineCount || 5000
        }
        // 1分钟K线数据（增量）
        let isIncre = Name === 'KLineChartContainer::RequestMinuteRealtimeData'
        if (isIncre) {
          dataCount = mklineCount || 240
        }
        if (isFull || isIncre) {
          if (fields.indexOf('time') < 0) {
            fields.push('time')
          }
        }
        // 日k线当日增量数据
        let isReal = Name === 'KLineChartContainer::RequestRealtimeData'
        if (isReal) {
          dataCount = 1
        }
        let newSymbol = Array.isArray(symbol) ? symbol[0] : symbol
        const opt = { field: fields, symbol: newSymbol, dataCount, candlePeriod }
        getKline(opt).then((r) => {
          let res = { code: 0, stock: [] }
          if (r.data.success) {
            res = r.data.candle
          }
          // 日K线，周K线和年K线记录最新日期
          const ln = res.data.length
          if (index < 4) {
            const lastItem = res.data[ln - 1]
            this.systemDate = lastItem[0]
          }
          // 分钟K线记录最新时间
          if (index >= 4 && ln && ln > 1) {
            // 取倒数第二条数据
            const lastItem = res.data[ln - 2]
            this.lastTime = lastItem[Object.keys(lastItem).length - 1]
          }
          // 开始处理分钟K线补录数据
          if (index >= 4) {
            res = this.makeupMinuteKline(index, res)
          }
          if (isIncre) {
            res.ver = 2.0// 使用2.0模式
          }
          // 构建日K线当日增量数据
          if (isReal && index === 0) {
            // 构建日K线当日增量数据
            res = this.getKlineRealData(res)
          }
          callback(res)
        }).catch((e) => {
          console.error(e)
        })
      }
    },
    increUpdateDayKline (data) {
      const { date, preclosePx, openPx, highPx, lowPx, lastPx, businessAmount, businessBalance } = data
      const r = {
        time: data.time,
        name: data.name,
        symbol: data.symbol + '.ET',
        data: [[date, preclosePx, openPx, highPx, lowPx, lastPx, businessAmount, businessBalance]]
      }
      let kline = this.getKlineRealData(r)
      kline.ver = 2.0
      // 日K线增量更新
      this.KLine.JSChart.JSChartContainer.RecvRealtimeData(kline)
    },
    increUpdateOtherKline (active) {
      const opt = {
        trans: true,
        dataCount: 1, // 取最新一条记录
        candlePeriod: period[active],
        symbol: this.prodCode + '.ET',
        field: ['name', 'symbol', 'yclose', 'open', 'price', 'high', 'low', 'vol', 'date']
      }
      getKline(opt).then(r => {
        if (r.data.success) {
          let kline = this.getKlineRealData(r.data.candle)
          kline.ver = 2.0
          this.KLine.JSChart.JSChartContainer.RecvRealtimeData(kline)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    increUpdateMinuteKline (active, date) {
      // 首次成交查询全量数据
      if (!this.lastTime) {
        const { data, func } = this.realKline
        return this.klineNetworkFilter(data, func)
      }
      const opt = {
        trans: true,
        date: date,
        searchDirection: 2,
        minTime: this.lastTime,
        candlePeriod: period[active],
        symbol: this.prodCode + '.ET',
        field: ['name', 'symbol', 'yclose', 'open', 'price', 'high', 'low', 'vol', 'date', 'time']
      }
      getKline(opt).then(r => {
        if (r.data.success) {
          let kline = r.data.candle
          kline.ver = 2.0
          this.KLine.JSChart.JSChartContainer.RecvMinuteRealtimeData(kline)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getTime () {
      return Number(dateFormat('HHMMSS'))
    },
    getTimeFormat (tsp) {
      return Number(dateFormat('HHMM', tsp))
    },
    getKlineRealData (candle) {
      let time = candle.time || this.getTime()
      const kline = { 'count': 1, 'code': 0 }
      let c = candle.data
      let r = c[c.length > 1 ? c.length - 1 : 0]
      const real = [{
        'time': time,
        'date': r[0],
        'price': r[5],
        'open': r[2],
        'yclose': r[1],
        'high': r[3],
        'low': r[4],
        'vol': r[6],
        'amount': r[7],
        'symbol': candle.symbol,
        'name': candle.name
      }]
      kline['stock'] = real
      return kline
    },
    refreshKline (data) {
      if (this.active === 1) {
        return this.minuteNetworkFilter(this.realMinute.data, this.realMinute.func)
      }
      if (this.active === 4) {
        return this.qryMinuteTick()
      }
      if (this.active === 2) {
        const { active } = this.klineBar
        if (active === 0) {
          // 日K线增量更新
          return this.increUpdateDayKline(data)
        }
        // 周K线,月K线,年K线增量更新
        if (active >= 1 && active <= 3) {
          return this.increUpdateOtherKline(active)
        }
        // 1分钟,5分钟,15分钟,30分钟,60分钟K线增量更新
        if (active >= 4) {
          this.increUpdateMinuteKline(active, data.date)
        }
      }
    },
    /**
      * get-分时图数据
      **/
    qryTrend (option, callback) {
      getTrend(option).then((r) => {
        callback(r.data)
      }).catch((e) => {
        console.error(e)
      })
    },
    /**
      * get-5日分时图数据
      **/
    qryTrendMinute (option, callback) {
      getTrendMinute(option).then((r) => {
        // 后台返回的数据，无法显示均线
        let trend = r.data.trend
        let dts = trend.data
        let ln = dts.length
        for (let i = 0; i < ln; i++) {
          let mins = dts[i].minute,
            lz = mins.length,
            minutes = []
          for (let j = 0; j < lz; j++) {
            minutes.push(Object.values(mins[j]))
          }
          dts[i].minute = minutes
        }
        callback(trend)
      }).catch((e) => {
        console.error(e)
      })
    },
    // 底部指标工具
    OnClickIndexBar (item, index) {
      this.menuIndex = index
      this.indexItem = item
      if (this.active === 1) {
        this.minIndex = index
        this.Minute.JSChart.ChangeIndex(2, item)
      } else if (this.active === 2) {
        this.kIndex = index
        if (item === 'BOLL') item = 'BOLL副图'
        this.KLine.JSChart.ChangeIndex(2, item)
      }
    },
    getTradeTime () {
      // 早晨的交易时间段
      const { Start, End } = tradeTime.Min[0]
      // 下午的交易时间段
      const begin = tradeTime.Min[1].Start
      const finish = tradeTime.Min[1].End
      return {ss: Start, se: End, sb: begin-1, sf: finish}
    },
    getMinutes (begin, finish) {
      let btime = begin < 1000 ? '0' + begin + '00' : begin.toString() + '00'
      let ftime = finish < 1000 ? '0' + finish + '00' : finish.toString() + '00'
      let dte = this.systemDate.toString()
      let d = dte.substring(0, 4)+ '/' + dte.substring(4, 6) + '/' + dte.substring(6, 8)
      let bdt = `${d} ${btime.match(/\d{1,2}/g).join(':')}`
      let fdt = `${d} ${ftime.match(/\d{1,2}/g).join(':')}`
      let btsp = new Date(bdt).getTime()
      let ftsp = new Date(fdt).getTime()
      return {min: (ftsp - btsp) / 1000 / 60, btsp: btsp, ftsp: ftsp}
    },
    /**
     * 分钟K线补线处理
     */
    makeupMinuteKline(idx, r) {
      // 记录服务器最新一条记录
      const st = this.systemTime
      const ln = r.data.length, price = this.prePrice
      const lastItem = ln > 0 ? r.data[ln - 1] : null
      // 分钟K线周期
      const obj = {4: 1, 5: 5, 6: 15, 7: 30, 8: 60}
      let step = obj[idx], klines = []
      // 获取交易时间段
      const { ss, se, sb, sf } = this.getTradeTime()
      // 当前没有任何成交
      if (!lastItem) {
        if (st < ss) {// 还没有开市
          klines = []
        } else if (st <= se && st >= ss) {// 当前系统时间在休市时间之前
          klines = this.getMinuteKline(price, ss, st, step)
        } else if (st > se && st < sb) {// 当前系统时间在休市时间之间
          klines = this.getMinuteKline(price, ss, se, step)
        } else if (st >= sb && st <= sf) {// 当前系统时间在休市时间之后，闭市时间之前
          let klines1 = this.getMinuteKline(price, ss, se, step)
          let klines2 = this.getMinuteKline(price, sb, st, step)
          klines = klines1.concat(klines2)
        } else {// 当前系统时间在闭市时间之后
          let klines1 = this.getMinuteKline(price, ss, se, step)
          let klines2 = this.getMinuteKline(price, sb, sf, step)
          klines = klines1.concat(klines2)
        }
        r.data = klines
        return r
      }
      // 已经有成交，取最新成交价
      const nprice = lastItem[5]
      const nt = lastItem[Object.keys(lastItem).length - 1]
      if (st <= se && st >= ss) {// 当前系统时间在休市时间之前
        klines = this.getMinuteKline(nprice, nt, st, step)
      } else if (st > se && st < sb) {// 当前系统时间在休市时间之间
        klines = this.getMinuteKline(nprice, nt, se, step)
      } else if (st >= sb && st <= sf) {// 当前系统时间在休市时间之后，闭市时间之前
        let klines1 = nt <= se ? this.getMinuteKline(nprice, nt, se, step) : []
        let sw = nt > sb ? nt : sb
        let klines2 = this.getMinuteKline(nprice, sw, st, step)
        klines = klines1.concat(klines2)
      } else {// 当前系统时间在闭市时间之后
        let klines1 = nt <= se ? this.getMinuteKline(nprice, nt, se, step) : []
        let sw = nt > sb ? nt : sb
        let klines2 = this.getMinuteKline(nprice, sw, sf, step)
        klines = klines1.concat(klines2)
      }
      // 数据合并
      r.data = r.data.concat(klines)
      return r
    },
    getMinuteKline (price, begin, finish, step = 1) {
      let klines = [], date = this.systemDate
      if (begin >= finish) {
        return klines
      }
      const {min, btsp, ftsp} = this.getMinutes(begin, finish)
      for(let i = step; i <= min; i+=step) {
        let time = this.getTimeFormat(i * 60 * 1000 + btsp)
        klines.push([date, 0, price, price, price, price, 0, 0, time])
      }
      return klines
    },
    // 设置颜色
    updateDataStyle (data) {
      const { preclosePx } = data
      this.prePrice = preclosePx
      let color0 = this.getColor(data.openPx, preclosePx)
      let color1 = this.getColor(data.highPx, preclosePx)
      let color2 = this.getColor(data.lowPx, preclosePx)
      let color3 = this.getColor(data.lastPx, preclosePx)
      let color4 = this.getColor(data.avgPx, preclosePx)
      let colorInfo = {
        openPx: { color: color0 },
        highPx: { color: color1 },
        lowPx: { color: color2 },
        lastPx: { color: color3 },
        preclosePx: { color: 'preclosePx' },
        pxChange: { color: color3 },
        pxChangeRate: { color: color3 },
        avgPx: { color: color4 },
        businessAmount: { color: 'amount' },
        currentAmount: { color: 'amount' },
        businessBalance: { color: 'amount' }
      }
      this.$bus.$emit('setDealStyle', colorInfo)
    },
    // 添加删除白名单
    editOptional () {
      let _this = this
      if (_this.hasOptional) {
        let index = optionsList.findIndex(v => v === _this.prodCode)
        if (index > -1) {
          optionsList.splice(index, 1)
          _this.hasOptional = false
          _this.$hMessage.info('已从自选板块删除')
        }
      } else {
        optionsList.push(_this.prodCode)
        _this.hasOptional = true
        _this.$hMessage.success('已添加自选板块')
      }
      setOptionalData('goodsOptionalData', optionsList)
    },
    accMulti (arg1, arg2, scale = 2) {
      let m = 0, s1 = arg1.toString(), s2 = arg2.toString()
      try { m += s1.split('.')[1].length } catch (e) { }
      try { m += s2.split('.')[1].length } catch (e) { }
      return (Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)).toFixed(scale)
    },
    groupBy (dataArray, groupFunc) {
      if (!dataArray || !dataArray.length) {
        return []
      }
      const groups = {}
      dataArray.forEach(o => {
        const grp = JSON.stringify(groupFunc(o))
        groups[grp] = groups[grp] || []
        groups[grp].push(o)
      })
      return Object.keys(groups).map(group => groups[group])
    },
    getTickOpt () {
      return {
        prodCode: this.prodCode,
        fields: tickFields,
        searchDirection: 1,
        dataCount: default_ticks
      }
    },
    // 查询分笔成交
    qryMinuteTick () {
      const opt = this.getTickOpt()
      getTicksList(opt).then(r => {
        if (r.data && r.data.tick && r.data.tick[this.prodCode]) {
          let ticks = r.data.tick[this.prodCode], tickArray = []
          let fields = r.data.tick.fields, yclose = r.data.yclose
          ticks = ticks.sort((a, b) => {
            let idx = this.getIndex(fields, 'business_time')
            // 成交时间升序排序
            return a[idx] - b[idx]
          })
          let prevColor
          for (let i in ticks) {
            let idx = Number(i)
            const { time, color, amount, price, balance } = this.getTickItem(ticks, idx, fields, yclose, prevColor)
            prevColor = color
            tickArray.push({
              time,
              color,
              vol: amount !== 0 ? unit.priceFormat(amount, 'businessAmount') : '-',
              balance: balance !== 0 ? unit.priceFormat(balance, 'businessBalance') : '-',
              price: price !== 0 ? price.toFixed(2) : '-'
            })
          }
          this.list = tickArray
          this.splitDataArray()
        }
      }).catch(e => {
        console.error(e)
      })
    },
    splitDataArray (height) {
      let dataList = []
      let split = this.getSplitData(height)
      this.minCols = split.minCols
      if (split.rows) {
        this.list.forEach((item, index) => {
          if (item.vol != '-') {
            let num = Math.floor(index / split.rows)
            if (!dataList[num]) {
              dataList[num] = []
            }
            dataList[num].push(item)
          }
        })
        this.dataList = dataList
        let totalCols = this.dataList.length
        this.totalPage = Math.ceil(totalCols / this.minCols)
        this.movingPixels = this.minCols * col_width
      }
    },
    // 分价成交
    qryPriceTable () {
      const opt = this.getTickOpt()
      getTicksList(opt).then(r => {
        if (r.data && r.data.tick && r.data.tick[this.prodCode]) {
          let ticks = r.data.tick[this.prodCode], tickArray = []
          let fields = r.data.tick.fields
          const buyArr = [], selArr = []
          for (let i in ticks) {
            let idx = Number(i)
            const item = this.getTickItem(ticks, idx, fields)
            if (item.amount <= 0 || item.balance <= 0) {
              continue
            }
            tickArray.push(item)
          }
          // 统计总成交数量
          const totalAmt = tickArray.map(o => o.amount).reduce((sum, num) => sum + num, 0)
          // 根据买卖方向分组
          const businessArr = this.groupBy(tickArray, o => [o.direction])
          businessArr.forEach(items => {
            if (items.length) {
              let { direction } = items[0]
              const priceGrp = this.groupBy(items, o => [o.price])
              priceGrp.forEach(parray => {
                let sumAmt = 0, sumBal = 0, { price } = parray[0]
                parray.length && parray.forEach(it => {
                  sumAmt += it.amount
                  sumBal += it.balance
                })
                let cnt = parray.length
                // 计算成交数量占比
                let rate = Number(sumAmt / totalAmt * 100).toFixed(2)
                let p = Number(price).toFixed(2)
                // let amt = Number(sumAmt).toFixed(2)
                let bal = Number(sumBal).toFixed(2)
                let hands = Number(sumAmt / this.goods.unit).toFixed(2)
                let amt = unit.priceFormat(sumAmt, 'businessAmount', true)
                let o = { price: p, amount: amt, balance: bal, count: cnt, rate, direct: direction, hands }
                if (direction === 1) {
                  buyArr.push(o)
                }
                if (direction === 0) {
                  selArr.push(o)
                }
              })
            }
          })
          let totalArr = buyArr.concat(selArr)
          totalArr = totalArr.sort((a, b) => {
            // 价格倒序排序
            return b['price'] - a['price']
          })
          totalArr = totalArr.map((item, idx) => {
            item.index = idx + 1
            return item
          })
          const business = this.groupBy(totalArr, o => [o.direct])
          if (!business.length) {
            this.buyTicks = this.selTicks = []
            return false
          }
          // 买单或卖单
          let busi = business[0]
          if (busi.length && busi[0].direct === 0) {
            this.selTicks = busi
          }
          if (busi.length && busi[0].direct === 1) {
            this.buyTicks = busi
          }
          busi = business[1]
          if (busi && busi.length && busi[0].direct === 0) {
            this.selTicks = busi
          }
          if (busi && busi.length && busi[0].direct === 1) {
            this.buyTicks = busi
          }
        }
      }).catch(e => {
        console.error(e)
      })
    },
    getTickItem (dataArray, idx, fields, yclose, prevColor) {
      let item = dataArray[idx]
      let priceIdx = this.getIndex(fields, 'hq_px')
      let price = item[priceIdx]
      let timeIdx = this.getIndex(fields, 'business_time')
      let amount = item[this.getIndex(fields, 'business_amount')]
      let time = item[timeIdx].toString().substr(8, 6).match(/\d{1,2}/g).join(':')
      // 重新计算分笔成交额，行情服务器返回的数据有误差
      // let balance = item[this.getIndex(fields, 'business_balance')]
      let balance = Number(this.accMulti(Number(price), Number(amount)))
      // 获取字体颜色
      let color = ''
      if (price && yclose) {
        // 第一笔成交和昨日收盘价比较
        // if (idx === 0) {
        color = this.getColor(price, yclose)
        color = color === 'PriceNull' ? '' : color
        // }
        // 第二笔成交和前一笔成交价比较
        // if (idx >= 1) {
        //   // 获取前一笔成交价格
        //   let prevPrice = dataArray[idx - 1][priceIdx]
        //   color = prevPrice === price ? prevColor : this.getColor(price, prevPrice)
        // }
      }
      let dirIdx = this.getIndex(fields, 'business_direction')
      // 买卖方向：0-卖；1-买
      let direction = item[dirIdx]
      return { time, price, amount, balance, color, direction }
    },
    getIndex (fields, key) {
      return fields.findIndex((a) => a === key)
    },
    getColor (price, yclose) {
      return this.operator.FormatValueColor(price, yclose)
    },
    busOff (keys) {
      if (!Array.isArray(keys)) {
        keys = [keys]
      }
      for (const key of keys) {
        this.$bus.$off(key)
      }
    },
    changeColor (curIndex, colIndex) {
      this.activeIndex = curIndex
      this.activeColIdx = colIndex
    },
    getSplitData (extHeight) {
      let dom = this.$refs['tickContainer']
      let domHeight = dom.clientHeight
      let width = dom.clientWidth, height = extHeight || (domHeight - 50)
      let cols = Math.ceil(width / col_width)
      let minCols = Math.floor(width / col_width)
      let rows = Math.floor(height / 26)
      return { width: width, minCols: minCols, cols: cols, rows: rows }
    },
    prevHandle () {
      if (this.pageNo > 1 && this.movingDistance > 0) {
        this.pageNo -= 1
        this.movingDistance -= this.movingPixels
        this.pageStyle.left = `${-this.movingDistance}px`
      }
    },
    nextHandle () {
      if (this.pageNo < this.totalPage) {
        this.pageNo += 1
        this.movingDistance += this.movingPixels
        this.pageStyle.left = `${-this.movingDistance}px`
      }
    },
    destroyChart () {
      if (this.Minute.JSChart) {
        this.Minute.JSChart.ChartDestory()
      }
      if (this.KLine.JSChart) {
        this.KLine.JSChart.ChartDestory()
      }
    },
    currentTime () {
      let date = new Date()
      let ldt = this.getLocalDate(date)
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      this.currDate = ldt
      this.currTime = h + ':' + m + ':' + s
    },
    getLocalDate (date) {
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      return `${y}-${m}-${d}`
    },
    showSystemTime (h, m, s) {
      let date = new Date()
      this.currDate = this.currDate || this.getLocalDate(date)
      h = h < 10 ? '0' + h : h
      m = m < 10 ? '0' + m : m
      s = s < 10 ? '0' + s : s
      this.totalTime += 1
      this.currTime = h + ':' + m + ':' + s
      this.systemTime = Number(h + '' + m)
      // 600s，即10分钟同步一次
      if (this.totalTime % 600 == 0) {
        this.syncServerTime()
        this.totalTime = 0
      }
    },
    getNextTimeNumber (h, m, s) {
      if (++s == 60) {
        s = 0
      }
      if (s == 0) {
        if (++m == 60) {
          m = 0
        }
        if (m == 0) {
          if (++h == 24) {
            h = 0
          }
        }
      }
      return [h, m, s]
    },
    updateLocalTime () {
      if (this.timerOne) {
        clearInterval(this.timerOne)
      }
      var ts = this.currTime.split(":", 3)
      var tms = [parseFloat(ts[0]), parseFloat(ts[1]), parseFloat(ts[2])]
      this.timerOne = setInterval(() => {
        tms = this.getNextTimeNumber(tms[0], tms[1], tms[2])
        this.showSystemTime(tms[0], tms[1], tms[2])
      }, 1000)
    },
    syncServerTime () {
      getServerTime().then(r => {
        if (r && r.data) {
          const { serverDate, serverTime } = r.data
          this.currDate = serverDate
          this.currTime = serverTime
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  user-select: none;
  -webkit-user-select: none;
}
.list-box {
  width: 100%;
  display: flex;
  margin-top: 16px;
  &-view {
    // width: 23%;
    .list-item {
      height: 26px;
      line-height: 26px;
      text-align: center;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      border-right: 1px solid #444;
      .label {
        cursor: default;
        font-size: 12px;
        margin-left: 20px;
      }
      .price {
        display: inline-block;
        cursor: default;
        width: 80px;
        text-align: right;
        font-size: 12px;
      }
      .count {
        display: inline-block;
        width: 80px;
        text-align: right;
        cursor: default;
        font-size: 12px;
        margin-right: 20px;
      }
    }
  }
}
/deep/#minute,
/deep/#kline {
  .klineframe-toolbar {
    // display: none !important;
  }
}
.graph-div {
  // background-color: #0a0b11;
  height: 100%;
  display: flex;
  .quote-graph-flex {
    flex: 1;
    overflow: hidden;
    width: 100%;
  }
  .tab {
    // float: left;
    width: 16px;
    min-height: 350px;
    &::after {
      display: block;
      clear: both;
      content: '.';
      height: 0;
      visibility: hidden;
      display: block;
    }
    .tab-buy {
      width: 100%;
      height: 130px;
      background: url(../../assets/ctlMain-tab-bg02.png) no-repeat;
      background-size: 100% 100%;
      text-align: center;
      color: #c7c7c7;
      overflow: hidden;
      p {
        writing-mode: vertical-lr;
        font-size: 12px;
        margin: 0 auto;
        letter-spacing: 3px;
        cursor: default;
        text-align: center;
        overflow: hidden;
        text-overflow: clip;
      }
    }
    .card_title_select {
      background: url(../../assets/ctlMain-tab-bg01.png) no-repeat;
      background-size: 100% 100%;
      color: #121212;
    }
  }
}
.active-arrow {
  transform: rotateX(180deg);
}
.quote-graph-container {
  background-color: #121212;
}

.tab-sell {
  width: 100%;
  height: 130px;
  background: url(../../assets/ctlMain-tab-bg02.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  color: #c7c7c7;
  overflow: hidden;
}
.tab-sell p {
  writing-mode: vertical-lr;
  letter-spacing: 3px;
  font-size: 12px;
  margin: 0 auto;
  cursor: default;
  vertical-align: middle;
  text-align: center;
  overflow: hidden;
  text-overflow: clip;
}
.menu-list {
  height: 24px;
  display: flex;
  line-height: 24px;
  background-color: #1e1f20;
  .item {
    width: 60px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
  }
  .item-active {
    background-color: #111111;
    color: #ffffff;
  }
}
.goods-info-p {
  line-height: 25px;
  overflow-y: auto;
  width: 100%;
  padding-bottom: 10px;
}
/deep/.optional-btn {
  background: #298dff;
  padding: 3px 5px;
  color: #ffffff;
  border: 0;
  margin-left: 6px;
  .iconfont {
    margin-right: -3px;
  }
  span {
    margin: 0 !important;
  }
}
/deep/.icon-index_param {
  display: none;
}
/deep/.icon-change_index {
  display: none;
}
.f10-container-wrap {
  padding-left: 40px;
  color: #9a893e;
}
.container-wrap {
  height: 100%;
}
.tick-container-wrap {
  height: calc(100% - 50px);
}
.f10-title {
  color: rgb(218, 194, 68);
  font-size: 18px;
  min-height: 35px;
  line-height: 35px;
  border-bottom: 1px solid #444;
}
.f10-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #909399;
}
.item-wrap {
  width: 34%;
  height: 34px;
  line-height: 34px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eee;
}
.item {
  display: flex;
  .label {
    width: 38%;
    color: #ffffff;
  }
  .price {
    width: 38%;
    text-align: right;
    font-size: 16px;
    color: #ffffff;
  }
  .count {
    text-align: right;
    width: 38%;
    font-size: 16px;
  }
}
.noright {
  float: left;
}
.margin-right-10 {
  margin-right: 10px;
}
.ticks-title {
  color: #909399;
  font-size: 18px;
  height: 34px;
  line-height: 34px;
}
.rate-table {
  /deep/ .h-table-fixed-body {
    overflow: hidden;
    position: relative;
    z-index: 0;
  }
  /deep/ .black .h-table {
    background: #121212;
    color: #a5a5a5;
    line-height: 1;
    th {
      background: #121212;
      border-bottom: 1px solid #444444;
    }
    td {
      background: #121212;
    }
  }
}
.rate-table-body {
  /deep/.h-table-fixed-right {
    .h-table-body-column-left {
      background-color: #121212;
    }
    .h-table-row-hover {
      td {
        background-color: #121212;
      }
    }
  }
  /deep/ .h-table {
    .h-table-body {
      position: relative;
      border-right: 1px solid #444444;
    }
    .h-table-tip {
      border-right: 1px solid #444444;
    }
    .h-table-tbody {
      .h-table-row-highlight {
        td {
          background-color: #121212;
        }
      }
      .h-table-row-hover td {
        background-color: #162a53;
      }
      line-height: 1;
      .table-tr-select td {
        background-color: #27498e;
      }
      tr.h-table-row td span {
        cursor: default;
        -webkit-user-select: none;
      }
      tr.h-table-row td div {
        cursor: default;
        -webkit-user-select: none;
      }
    }
  }
}
.rate-table-body /deep/ .h-progress-inner {
  border-radius: 0;
  background-color: #121212;
}
.rate-table-body /deep/ .h-progress-bg {
  background-color: #ff5454 !important;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  position: relative;
}
.tick-active {
  background: #162a53;
}
.pageBar {
  position: absolute;
  top: 20px;
  right: 10px;
}
.pageBar /deep/ .h-btn-text span {
  color: #DEDEDE !important;
  font-size: 11px;
}
.preclosePx {
  color: #DEDEDE;
}
</style>
